module.exports = __webpack_public_path__ + "img/cabeza_success.10b37ea2.svg";